<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="30vw"
    :value="value"
    loading
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-toolbar color="primary" dark>
      <v-toolbar-title>Редактировать виджет ({{ label }})</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-container fluid>

        <v-row class="mt-n2">
          <v-col>
            <v-text-field label="Имя виджета" v-model="name"></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && widget.currentView">
          <v-col>
            <ViewSelector v-model="view" />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'period' in widget.params">
          <v-col>
            <PeriodSelector v-model="period" />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'projects' in widget.params">
          <v-col>
            <v-checkbox
              v-model="isAllProjects"
              label="Все мои проекты"
            />
            <ProjectSelector
              v-model="projects"
              noRules
              :disabled="isAllProjects"
            />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'campaigns' in widget.params">
          <v-col>
            <v-checkbox
              v-model="isAllCampaigns"
              label="Все мои кампании"
            />
            <CampaignSelector
              v-model="campaigns"
              noRules
              :disabled="isAllCampaigns"
              dont-link-to-project
            />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'projectsSingle' in widget.params">
          <v-col>
            <ProjectSelector
              v-model="projects"
              single
              noRules
            />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'groups' in widget.params">
          <v-col>
            <GroupSelector v-model="groups" />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'type' in widget.params">
          <v-col>
          <p>Тип</p>
          <v-radio-group
            v-model="type"
            mandatory
          >
            <v-radio
              label="Поминутно"
              value="min"
            ></v-radio>
            <v-radio
              label="Посекундно"
              value="sec"
            ></v-radio>
          </v-radio-group>
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'only_low_sla' in widget.params">
          <v-col>
            <v-checkbox
              v-model="only_low_sla"
              label="Показывать только проекты с невыполненным сервисом или SLA"
            />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'only_forecast' in widget.params">
          <v-col>
            <v-checkbox
              v-model="only_forecast"
              label="Показывать только прогноз"
            />
          </v-col>
        </v-row>

        <v-row class="mt-n2" v-if="widget && 'params' in widget && 'users' in widget.params">
          <v-col>
            <UserSelector v-model="users" />
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="saveWidget">Сохранить</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>


<script>
// import moment from "moment";
import { mapActions, mapGetters } from "vuex";

import ViewSelector from '~/components/partials/selectors/ViewSelector.vue';
import PeriodSelector from '~/components/partials/selectors/PeriodSelector.vue';
import GroupSelector from '~/components/partials/selectors/GroupSelector.vue';
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';
import UserSelector from '~/components/partials/selectors/UserSelector.vue';
import CampaignSelector from '~/components/partials/selectors/CampaignSelector.vue';

export default {
  name: 'EditWidget',
  components: {
    ViewSelector,
    PeriodSelector,
    GroupSelector,
    ProjectSelector,
    UserSelector,
    CampaignSelector,
  },
  props: {
    value: Boolean,
    widgetId: String,
  },
  data() {
    return {
      widget: null,
      name: '',
      view: [],
      period: '',
      groups: [],
      users: [],
      projects: [],
      isAllProjects: false,
      campaigns: [],
      isAllCampaigns: false,
      only_low_sla: false,
      only_forecast: false,
      type: '',
      widgetTypes: [
        {type: 'TableSl', name: 'Таблица SL'},
        {type: 'EmploymentWidget', name: 'Занятость'},
        {type: 'AcceptedMissed', name: 'Принятые/Пропущенные'},
        {type: 'GroupByOperator', name: 'Вызовы по операторам'},
        {type: 'HourlyDynamics', name: 'Почасовая динамика'},
        {type: 'ExtendedCall', name: 'Информация по вызовам'},
        {type: 'OksReport', name: 'Окс отчёт'},
        {type: 'AvgAgentTime', name: 'Вызовы по дням'},
        {type: 'TransferWidget', name: 'Переведённые вызовы'},
        {type: 'ForecastCalls', name: 'Прогноз вызовов по дням'},
        {type: 'OutgoingCalls', name: 'Информация по исходящим вызовам'},
        {type: 'OutgoingByOperators', name: 'Исходящие по операторам'},
        {type: 'StatisticByOperators', name: 'Статистика по операторам'},
        {type: 'VuelinerTable', name: 'Мониторинг звонков'},
        {type: 'StatisticByQueues', name: 'Статистика по очередям'},
        {type: 'OperatorCampaignStatiscticByDays', name: 'Разбивка операторов по Кампаниям'},
        {type: 'PercentageAcceptByCampaign', name: 'Процент принятых по кампаниям'},
      ],
    }
  },

  computed: {
    ...mapGetters({
      dashboard: 'dashboard/dashboard',
    }),

    label() {
      if (this.widget) {
        let type = this.widgetTypes.find(t => t.type === this.widget.type)
        return type.name
      } else return ''
    },
  },

  watch: {

  },

  methods: {
    ...mapActions({
      changeEditedWidgetId: 'dashboard/changeEditedWidgetId',
    }),
    close() {
      this.$emit('input', false)
    },


    resetWidget() {
      let index = this.dashboard.widgets.findIndex(w => w.id === this.widgetId);
      let tmpWidget = JSON.parse(JSON.stringify(this.widget));
      this.dashboard.widgets.splice(index, 1);
      setTimeout(() => {
        this.dashboard.widgets.push(tmpWidget);
      }, 100);
    },

    saveWidget() {
      this.widget.name = this.name
      if ('views' in this.widget) {
        this.widget.views = this.view
        this.widget.currentView = this.view[0]
      }
      if (!('params' in this.widget)) {
        this.close()
        return
      }
      if ('period' in this.widget.params) this.widget.params.period = this.period
      if ('groups' in this.widget.params) this.widget.params.groups = this.groups

      if ('projectsSingle' in this.widget.params) this.widget.params.projectsSingle = this.projects
      if ('projects' in this.widget.params) {
        if (this.isAllProjects) this.projects = []
        this.widget.params.projects = this.projects
      }
      if ('isAllProjects' in this.widget.params) this.widget.params.isAllProjects = this.isAllProjects

      if ('campaigns' in this.widget.params) {
        if (this.isAllCampaigns) this.campaigns = []
        this.widget.params.campaigns = this.campaigns
      }
      if ('isAllCampaigns' in this.widget.params) this.widget.params.isAllCampaigns = this.isAllCampaigns

      if ('type' in this.widget.params) this.widget.params.type = this.type
      if ('only_low_sla' in this.widget.params) this.widget.params.only_low_sla = this.only_low_sla
      if ('only_forecast' in this.widget.params) this.widget.params.only_forecast = this.only_forecast
      if ('users' in this.widget.params) this.widget.params.users = this.users

      this.resetWidget()
      this.changeEditedWidgetId(this.widget.id) //другой способ "обновления" виджетов
      this.close()
    },

    getRandomString(length) {
      let simbols = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
      let out = ''

      for (let i = 0; i < length; i++) {
        out += simbols[Math.floor(Math.random() * simbols.length)]
      }
      return out
    },

  },

  mounted() {
    this.widget = this.dashboard.widgets.find(w => w.id === this.widgetId)
    this.name = this.widget.name
    if ('views' in this.widget) {
      this.view = this.widget.views
    }
    if ('params' in this.widget) {
      this.period = this.widget.params.period
      this.groups = this.widget.params.groups
      this.projects = this.widget.params.projects || this.widget.params.projectsSingle
      this.isAllProjects = this.widget.params.isAllProjects
      this.campaigns = this.widget.params.campaigns
      this.isAllCampaigns = this.widget.params.isAllCampaigns
      this.type = this.widget.params.type
      this.only_low_sla = this.widget.params.only_low_sla
      this.only_forecast = this.widget.params.only_forecast
      this.users = this.widget.params.users
    }
  },

}
</script>


<style scoped lang="scss">

</style>